import { render, staticRenderFns } from "./PageDroneAssessment.vue?vue&type=template&id=67fccabc&scoped=true&"
import script from "./PageDroneAssessment.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PageDroneAssessment.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fccabc",
  null
  
)

export default component.exports